export class GridTypeEnum
{
  static Audit = "audit";
  static Main = "main";
  static Sync = "sync";
  static Containermapping = "containermapping";
  static Basemapping = "basemapping";
  static OnboardedApp = "onboardedapp";
}
